<div class="content-box">
  <section class="manifestacao" aria-labelledby="manifestacao-titulo">
    <app-breadcrumb [pagina]="manifestacao().titulo" [intermediarios]="trilha"></app-breadcrumb>

    <div class="manifestacao-topo">
      <h1 class="manifestacao-titulo" id="manifestacao-titulo">{{ manifestacao().titulo }}</h1>

      <div class="manifestacao-acoes">
        <button
          type="button"
          class="manifestacao-botao manifestacao-enviar"
          (click)="irParaLogin()"
        >
          <i-lucide name="send" size="16" aria-hidden="true"></i-lucide>
          Enviar {{ manifestacao().rotulo }}
        </button>
      </div>
    </div>

    <img
      class="manifestacao-banner"
      [ngSrc]="manifestacao().banner"
      [width]="manifestacao().bannerLargura"
      [height]="manifestacao().bannerAltura"
      priority
      alt=""
    />

    <app-etapas-servico
      #trilhaEtapas
      [etapas]="etapas"
      [etapaAtual]="etapaAtual()"
      [etapaLiberada]="etapaLiberada()"
      [mensagemBloqueio]="mensagemBloqueio()"
      (selecionar)="irParaEtapa($event)"
    ></app-etapas-servico>

    @switch (etapaAtual()) {
      @case (0) {
        <app-etapa-informacoes-ouvidoria
          [titulo]="manifestacao().titulo"
          [icone]="manifestacao().icone"
          [descricao]="manifestacao().descricao"
          [sessaoIniciada]="store.sessaoIniciada()"
          [focarLogin]="focarLogin()"
          [canalDisponivel]="podeLiberarSolicitacao()"
          [permiteAnonimato]="ouvidoria.permiteAnonimato()"
          [estadoCanal]="ouvidoria.estadoCanal()"
          [prazoTexto]="ouvidoria.prazoTexto()"
          (acessarGov)="solicitar()"
          (solicitar)="solicitar()"
          (seguirAnonimo)="seguirAnonimo()"
          (autenticado)="autenticar()"
          (saiu)="encerrarSessao()"
          (tentarNovamente)="recarregarCanal()"
        ></app-etapa-informacoes-ouvidoria>
      }
      @case (1) {
        <app-etapa-solicitacao-ouvidoria
          [rotuloDescricao]="manifestacao().rotuloDescricao"
          [placeholderDescricao]="manifestacao().placeholderDescricao"
        ></app-etapa-solicitacao-ouvidoria>
      }
      @case (2) {
        <app-etapa-prazo-ouvidoria></app-etapa-prazo-ouvidoria>
      }
      @case (3) {
        <app-etapa-confirmacao-ouvidoria
          [servico]="manifestacao().titulo"
          (novaManifestacao)="reiniciar()"
        ></app-etapa-confirmacao-ouvidoria>
      }
    }

    @if (etapaAtual() > 0 && etapaAtual() !== etapaConfirmacao) {
      <div class="manifestacao-navegacao">
        <button type="button" class="manifestacao-botao manifestacao-voltar" (click)="voltar()">
          <i-lucide name="arrow-left" size="16" aria-hidden="true"></i-lucide>
          Voltar
        </button>

        <div class="manifestacao-navegacao-final">
          @if (store.preenchido()) {
            <button
              type="button"
              class="manifestacao-botao manifestacao-cancelar"
              (click)="cancelar()"
            >
              Cancelar {{ manifestacao().rotulo.toLowerCase() }}
            </button>
          }

          @if (etapaAtual() === etapaPrazo) {
            <button
              type="button"
              class="manifestacao-botao manifestacao-avancar"
              [disabled]="enviando()"
              [attr.aria-busy]="enviando()"
              (click)="enviar()"
            >
              <i-lucide
                [name]="enviando() ? 'loader-circle' : 'send'"
                size="16"
                [class.manifestacao-girando]="enviando()"
                aria-hidden="true"
              ></i-lucide>
              {{ enviando() ? 'Enviando...' : 'Enviar ' + manifestacao().rotulo.toLowerCase() }}
            </button>
          } @else if (etapaAtual() < etapaConfirmacao) {
            <button
              type="button"
              class="manifestacao-botao manifestacao-avancar"
              (click)="avancar()"
            >
              Avançar
              <i-lucide name="arrow-right" size="16" aria-hidden="true"></i-lucide>
            </button>
          }
        </div>
      </div>
    }
  </section>
</div>
